import { isIE } from "@1js/acui-common";

/**
 * This object is a subset of ribbonExperiments that the static ribbon depends on. To reduced unnecessary code from being pulled into that bundle, the object is split up
 */
export const staticRibbonExperiments = {
  sharedShyRibbonIsEnabled: "SharedShyRibbonIsEnabled",
  reactSharedHeaderIsEnabled: "ReactSharedHeaderIsEnabled",
  hideHeaderEmbedded: "HideHeaderEmbedded",
  ribbonScalingSafeguard: "SharedOnline.ChangeGate.RibbonScalingSafeguard",
  ribbonScalingSafeguardTopBar:
    "SharedOnline.ChangeGate.RibbonScalingSafeguardTopBar",
  doNotMeasureHiddenPreviewGalleryItems:
    "SharedOnline.ChangeGate.doNotMeasureHiddenPreviewGalleryItems",
  deterministicRibbonScaling:
    "Microsoft.Office.SharedOnline.DeterministicRibbonScaling",
};

export const isShyRibbonFeatureEnabled = (
  isFeatureEnabled?: (
    feature: string,
    defaultValue?: boolean | undefined
  ) => boolean
) => {
  return (
    isFeatureEnabled !== undefined &&
    isFeatureEnabled(staticRibbonExperiments.sharedShyRibbonIsEnabled) &&
    isFeatureEnabled(staticRibbonExperiments.reactSharedHeaderIsEnabled) &&
    !isFeatureEnabled(staticRibbonExperiments.hideHeaderEmbedded) &&
    !isIE()
  );
};
